import { ReactElement, useCallback, useId } from 'react';

import {
	BackgroundImage,
	BackgroundImageWrapper,
	BadgeGrid,
	CardContainer,
	DateTime,
	ImageWrapper,
	InfoContainer,
	LockIcon,
	LockWithBadge,
	MultipleBadges,
	Subtitle,
	Title,
} from './styles';
import { ContentCardProps } from './types';

const ContentCard = ({
	key,
	width,
	height,
	isDisabled = false,
	onClick,
	href,
	title,
	subtitle,
	dateTime,
	badges,
	image,
	blurDataURL,
	imageAltText,
	is_unlocked = true,
}: ContentCardProps): ReactElement => {
	const safeOnClick = useCallback(() => {
		if (onClick && !isDisabled) {
			onClick();
		}
	}, [onClick, isDisabled]);
	const showInfo = title || subtitle || dateTime;
	const infoId = useId();
	return (
		<CardContainer
			onClick={safeOnClick}
			$isDisabled={isDisabled}
			aria-disabled={isDisabled}
			key={key}
			href={href}
			role={onClick && !href ? 'button' : undefined}
		>
			<ImageWrapper width={width} height={height}>
				<BackgroundImageWrapper>
					{!is_unlocked && !badges && <LockIcon />}
					{badges && badges.length > 0 && (
						<BadgeGrid data-testid="badge-grid">
							{!is_unlocked && (
								<LockWithBadge>
									<LockIcon />
								</LockWithBadge>
							)}
							{badges.map(badge => {
								return <MultipleBadges key={badge}>{badge}</MultipleBadges>;
							})}
						</BadgeGrid>
					)}
					<BackgroundImage
						alt={imageAltText ?? title ?? ''}
						aria-labelledby={!imageAltText && showInfo ? infoId : undefined}
						placeholder="blur"
						blurDataURL={blurDataURL}
						fill
						src={image}
					/>
				</BackgroundImageWrapper>
			</ImageWrapper>
			{showInfo && (
				<InfoContainer id={infoId}>
					{title && <Title>{title}</Title>}
					{subtitle && <Subtitle>{subtitle}</Subtitle>}
					{dateTime && <DateTime>{dateTime}</DateTime>}
				</InfoContainer>
			)}
		</CardContainer>
	);
};

export default ContentCard;
